import React, { useState } from "react";
import classNames from "classnames";
import { Expand } from "Components/Icons";

import defaultStyles from "./Accordion.module.scss";

type Styles = Record<"accordion" | "accordionHeader" | "accordionIcon" | "accordionExpendedIcon" | "accordionTitle" | "accordionDescription" | "accordionExpendedDescription", string>;

// const classes: Styles = stylesModule as unknown as any;

type HTMLDivType = Omit<React.HTMLAttributes<HTMLDivElement>, "onChange">;

export interface AccordionProps extends AccordionUncontrolledProps {
   expanded?: boolean;
   onChange?: (event: React.SyntheticEvent, newExpanded: boolean) => void;
}

const Accordion: React.FC<AccordionProps> = ({
   title,
   children,
   expanded = false,
   onChange,
   className,
   stylesModule,
   ...props
}) => {
   const classes = { ...defaultStyles, ...stylesModule };

   return (
      <div className={classNames(classes.accordion, className)} {...props}>
         <div
            className={classes.accordionHeader}
            onClick={(e) => onChange?.(e, !expanded)}
         >
            <Expand
               className={classNames(
                  classes.accordionIcon,
                  expanded && classes.accordionExpendedIcon
               )}
            />
            <div className={classes.accordionTitle}>{title}</div>
         </div>
         <div
            className={classNames(
               classes.accordionDescription,
               expanded && classes.accordionExpendedDescription
            )}
         >
            {children}
         </div>
      </div>
   );
};

export default Accordion;

export interface AccordionUncontrolledProps extends HTMLDivType {
   title?: string;
   initiallyExanded?: boolean;
   stylesModule?: Partial<Styles>
}

export const AccordionUncontrolled: React.FC<AccordionUncontrolledProps> = ({ initiallyExanded: initialState, ...rest }) => {
   const [expanded, setExpanded] = useState(initialState ?? false);
   return <Accordion expanded={expanded} onChange={(_, v) => setExpanded(v)} {...rest} />
}

